import { RequestService } from 'services/RequestService/RequestService';

import { alertEvent } from 'stores/Alert/AlertEvents';
import { authStore } from 'stores/AuthStore/AuthStore';
import { partnersManagementEvent } from 'stores/PartnersManagement/PartnersManagementEvents';

import { getPartnersDetailsUseCase } from './getPartnersDetailsUseCase';
import { getPartnersManagementUseCase } from './getPartnersManagementUseCase';

const execute = async (form: any) => {
  try {
    const { sector } = authStore.getState();

    await RequestService.editValidityRequestManagementDetail({
      id: form.formId,
      userSector: sector,
      validityStart: form.startDate,
      validityEnd: form.endDate,
      examQty: form?.examQty ? Number(form.examQty) : null,
      prescriptionQty: form?.prescriptionQty ? Number(form.prescriptionQty) : null,
    });

    alertEvent({
      open: true,
      text: 'Vigência alterada com sucesso.',
      type: 'success',
    });
  } catch (err) {
    // console.log(err)
  } finally {
    partnersManagementEvent({ isOpenEditValidityModal: false });
    getPartnersDetailsUseCase.execute();
    getPartnersManagementUseCase.execute();
  }
};

export const editValidityModalPartnersManagementUseCase = { execute };
